import * as i4$2 from '@capturum/ui/paginator';
import { CapturumPaginatorModule } from '@capturum/ui/paginator';
import * as i4$1 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i0 from '@angular/core';
import { Component, Injectable, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from '@capturum/builders/form-renderer';
import { CapturumFormRendererModule } from '@capturum/builders/form-renderer';
import * as i1$1 from '@capturum/builders/list-renderer';
import { CapturumListRendererModule } from '@capturum/builders/list-renderer';
import { DestroyBase } from '@capturum/shared';
import { models } from 'powerbi-client';
import * as i6 from 'powerbi-client-angular';
import { PowerBIReportEmbedComponent, PowerBIEmbedModule } from 'powerbi-client-angular';
import { Subject, from, Subscription } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { ApiService } from '@capturum/api';
import * as i2 from '@capturum/auth';
import * as i3 from '@capturum/ui/api';
import { ToastService } from '@capturum/ui/api';
import * as i4 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$2 from 'primeng/dynamicdialog';
import * as i3$1 from '@capturum/builders/core';
import { CapturumBuilderCoreModule } from '@capturum/builders/core';
function CapturumPowerBIReportsDetailComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "cap-power-bi-report", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const reportId_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("reportId", reportId_r1);
  }
}
function CapturumPowerBiPaginatorComponent_div_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "cap-button", 6);
    i0.ɵɵlistener("onClick", function CapturumPowerBiPaginatorComponent_div_0_div_1_div_1_Template_cap_button_onClick_1_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r8);
      const page_r6 = restoredCtx.$implicit;
      const ctx_r7 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r7.setPage(page_r6));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const page_r6 = ctx.$implicit;
    i0.ɵɵclassProp("active", page_r6.isActive);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", page_r6.displayName)("styleClass", page_r6.isActive ? "primary round" : "secondary round");
  }
}
function CapturumPowerBiPaginatorComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, CapturumPowerBiPaginatorComponent_div_0_div_1_div_1_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pages_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", pages_r3)("ngForTrackBy", ctx_r4.trackByFn);
  }
}
function CapturumPowerBiPaginatorComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CapturumPowerBiPaginatorComponent_div_0_div_1_Template, 2, 2, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.styleClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAsList)("ngIfElse", _r1);
  }
}
function CapturumPowerBiPaginatorComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cap-paginator", 7);
    i0.ɵɵlistener("changePage", function CapturumPowerBiPaginatorComponent_ng_template_2_Template_cap_paginator_changePage_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.setPage($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("pagination", ctx_r2.pagination);
  }
}
let ReportsLayoutComponent = /*#__PURE__*/(() => {
  class ReportsLayoutComponent {
    static {
      this.ɵfac = function ReportsLayoutComponent_Factory(t) {
        return new (t || ReportsLayoutComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ReportsLayoutComponent,
        selectors: [["cap-pbi-reports"]],
        decls: 1,
        vars: 0,
        template: function ReportsLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "router-outlet");
          }
        },
        dependencies: [i1.RouterOutlet],
        encapsulation: 2
      });
    }
  }
  return ReportsLayoutComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var EventHandlers = /*#__PURE__*/function (EventHandlers) {
  EventHandlers["loaded"] = "loaded";
  EventHandlers["rendered"] = "rendered";
  EventHandlers["error"] = "error";
  EventHandlers["visualClicked"] = "visualClicked";
  EventHandlers["pageChanged"] = "pageChanged";
  return EventHandlers;
}(EventHandlers || {});
var ReportType = /*#__PURE__*/function (ReportType) {
  ReportType["report"] = "report";
  ReportType["dashboard"] = "dashboard";
  ReportType["tile"] = "tile";
  ReportType["visual"] = "visual";
  ReportType["qna"] = "qna";
  return ReportType;
}(ReportType || {});
let PowerBiApiService = /*#__PURE__*/(() => {
  class PowerBiApiService extends ApiService {
    constructor() {
      super(...arguments);
      this.endpoint = '/power-bi/report';
    }
    getEmbedConfig(endpoint, reportId) {
      return this.apiHttp.get(`${endpoint ?? this.endpoint}/${reportId}/get-token`).pipe(map(response => response.data));
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵPowerBiApiService_BaseFactory;
        return function PowerBiApiService_Factory(t) {
          return (ɵPowerBiApiService_BaseFactory || (ɵPowerBiApiService_BaseFactory = i0.ɵɵgetInheritedFactory(PowerBiApiService)))(t || PowerBiApiService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PowerBiApiService,
        factory: PowerBiApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PowerBiApiService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PowerBIService = /*#__PURE__*/(() => {
  class PowerBIService {
    constructor() {
      this.setPage$ = new Subject();
      this._pages$ = new Subject();
    }
    pages() {
      return this._pages$.asObservable();
    }
    setActivePage() {
      return this.setPage$.asObservable();
    }
    setPages(pages) {
      this._pages$.next(pages);
    }
    static {
      this.ɵfac = function PowerBIService_Factory(t) {
        return new (t || PowerBIService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PowerBIService,
        factory: PowerBIService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PowerBIService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultLanguageSettings = {
  language: 'en',
  locale: 'en-en'
};
let CapturumPowerBiReportComponent = /*#__PURE__*/(() => {
  class CapturumPowerBiReportComponent extends DestroyBase {
    constructor(apiService, authService, toastService, translateService, powerBIservice) {
      super();
      this.apiService = apiService;
      this.authService = authService;
      this.toastService = toastService;
      this.translateService = translateService;
      this.powerBIservice = powerBIservice;
      this.styleClass = '';
      this.isEmbedded = false;
      this.eventHandlersMap = new Map([[EventHandlers.loaded, this.reportLoaded.bind(this)], [EventHandlers.rendered, this.reportRenderered.bind(this)], [EventHandlers.error, this.reportError.bind(this)]]);
      this._reportConfig = {
        type: ReportType.report,
        embedUrl: undefined,
        tokenType: models.TokenType.Embed,
        accessToken: undefined,
        settings: {
          panes: {
            bookmarks: {
              visible: false
            },
            fields: {
              visible: false,
              expanded: false
            },
            filters: {
              expanded: false,
              visible: false
            },
            pageNavigation: {
              visible: false,
              position: models.PageNavigationPosition.Left
            },
            selection: {
              visible: false
            },
            syncSlicers: {
              visible: false
            },
            visualizations: {
              visible: false,
              expanded: false
            }
          },
          localeSettings: {
            formatLocale: defaultLanguageSettings.locale,
            language: defaultLanguageSettings.language
          }
        }
      };
    }
    /**
     * To bootstrap powerbi entity, pass the property embedConfig to the component without accessToken
     */
    get reportConfig() {
      return this._reportConfig;
    }
    set reportConfig(config) {
      this._reportConfig = {
        ...this._reportConfig,
        ...config
      };
    }
    ngOnChanges(changes) {
      if (changes.reportPage?.previousValue !== changes.reportPage?.currentValue || changes.reportId?.previousValue !== changes.reportId?.currentValue) {
        this.setReportActivePage();
        this.getNewReportConfig();
      }
    }
    ngOnInit() {
      this.getNewReportConfig();
    }
    getNewReportConfig() {
      const user = this.authService.getUser();
      const userFormatLocale = user?.locale?.code + '-' + user?.locale?.code;
      this.reportConfig = {
        ...this.reportConfig,
        settings: {
          ...this.reportConfig.settings,
          localeSettings: {
            formatLocale: userFormatLocale || this.localeSettings?.locale || this.reportConfig.settings.localeSettings.formatLocale,
            language: user?.locale?.code || this.localeSettings?.language || defaultLanguageSettings.language
          }
        }
      };
      if (this.reportId) {
        this.apiService.getEmbedConfig(this.tokenEndpoint, this.reportId).pipe(takeUntil(this.destroy$)).subscribe(config => {
          if (config) {
            this.reportConfig = {
              ...this.reportConfig,
              id: config.report_id,
              embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${config.report_id}`,
              accessToken: config.token
            };
            if (config.page_name) {
              this.reportPage = config.page_name;
            }
          }
        });
      }
      this.powerBIservice.setActivePage().pipe(takeUntil(this.destroy$), filter(page => page.reportKey === this.reportId)).subscribe(page => {
        this.report.setPage(page.pageName);
      });
    }
    /**
     * Event Handler when report is initialized
     */
    reportLoaded() {
      this.setReportActivePage();
    }
    setReportActivePage() {
      const report = this.reportComponent?.getReport();
      if (report) {
        from(report.getPages()).pipe(map(pages => pages.filter(page => page.visibility === 0).find(page => page.displayName === this.reportPage)), filter(Boolean), takeUntil(this.destroy$)).subscribe(page => page.setActive());
      }
    }
    /**
     * Event handler for errors of report
     * @param event error
     */
    reportError(event) {
      if (event) {
        this.toastService.error(this.translateService.instant('toast.error.title'), event.detail);
      }
    }
    /**
     * Report has rendered
     */
    reportRenderered() {
      // Update embed status
      this.isEmbedded = true;
      this.report = this.reportComponent.getReport();
      if (this.report) {
        from(this.report.getPages()).pipe(map(pages => pages.filter(page => page.visibility === 0)), takeUntil(this.destroy$)).subscribe(pages => this.powerBIservice.setPages(pages));
      }
    }
    static {
      this.ɵfac = function CapturumPowerBiReportComponent_Factory(t) {
        return new (t || CapturumPowerBiReportComponent)(i0.ɵɵdirectiveInject(PowerBiApiService), i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i3.ToastService), i0.ɵɵdirectiveInject(i4.TranslateService), i0.ɵɵdirectiveInject(PowerBIService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBiReportComponent,
        selectors: [["cap-power-bi-report"]],
        viewQuery: function CapturumPowerBiReportComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(PowerBIReportEmbedComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportComponent = _t.first);
          }
        },
        inputs: {
          reportId: "reportId",
          styleClass: "styleClass",
          reportPage: "reportPage",
          tokenEndpoint: "tokenEndpoint",
          localeSettings: "localeSettings",
          reportConfig: "reportConfig"
        },
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 3,
        consts: [[3, "embedConfig", "cssClassName", "eventHandlers"]],
        template: function CapturumPowerBiReportComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "powerbi-report", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("embedConfig", ctx.reportConfig)("cssClassName", "cap-power-bi-report " + ctx.styleClass)("eventHandlers", ctx.eventHandlersMap);
          }
        },
        dependencies: [i6.PowerBIReportEmbedComponent],
        styles: [".cap-power-bi-report{aspect-ratio:16/9}@supports not (aspect-ratio: auto){.cap-power-bi-report{padding-top:56.25%;height:0;position:relative;overflow:hidden}}@supports not (aspect-ratio: auto){.cap-power-bi-report>iframe{position:absolute;top:0;left:0}}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumPowerBiReportComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBIReportsListComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIReportsListComponent {
    static {
      this.ɵfac = function CapturumPowerBIReportsListComponent_Factory(t) {
        return new (t || CapturumPowerBIReportsListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIReportsListComponent,
        selectors: [["cap-pbi-reports-list"]],
        decls: 1,
        vars: 0,
        consts: [["key", "list_power_bi_reports"]],
        template: function CapturumPowerBIReportsListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cpb-list-renderer", 0);
          }
        },
        dependencies: [i1$1.CapturumListRendererComponent]
      });
    }
  }
  return CapturumPowerBIReportsListComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBIReportsDetailComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIReportsDetailComponent {
    constructor(route) {
      this.route = route;
    }
    ngOnInit() {
      this.reportId$ = this.route.params.pipe(filter(params => params.id), map(({
        id
      }) => id));
    }
    static {
      this.ɵfac = function CapturumPowerBIReportsDetailComponent_Factory(t) {
        return new (t || CapturumPowerBIReportsDetailComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIReportsDetailComponent,
        selectors: [["cap-pbi-reports-detail"]],
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [3, "reportId"]],
        template: function CapturumPowerBIReportsDetailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumPowerBIReportsDetailComponent_div_0_Template, 2, 1, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.reportId$));
          }
        },
        dependencies: [i2$1.NgIf, CapturumPowerBiReportComponent, i2$1.AsyncPipe]
      });
    }
  }
  return CapturumPowerBIReportsDetailComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const reportsRoutes = [{
  path: 'reports',
  component: ReportsLayoutComponent,
  children: [{
    path: '',
    component: CapturumPowerBIReportsListComponent
  }, {
    path: 'report/:id',
    component: CapturumPowerBIReportsDetailComponent
  }]
}];
const routerModule = RouterModule.forChild(reportsRoutes);
let CapturumPowerBIRoutingModule = /*#__PURE__*/(() => {
  class CapturumPowerBIRoutingModule {
    static {
      this.ɵfac = function CapturumPowerBIRoutingModule_Factory(t) {
        return new (t || CapturumPowerBIRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumPowerBIRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [routerModule, RouterModule]
      });
    }
  }
  return CapturumPowerBIRoutingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PowerBIManageDetailsBase {
  constructor(formSaverService, config, dialogRef, actionService) {
    this.formSaverService = formSaverService;
    this.config = config;
    this.dialogRef = dialogRef;
    this.actionService = actionService;
    this.item = this.config?.data?.item;
    this.modelId = this.config?.data?.item?.id;
    this._action = this.config?.data?.action;
  }
  submit() {
    this.formSaverService.submit(this.key).subscribe(response => {
      if (response) {
        this.close();
      }
    });
  }
  close() {
    this.dialogRef.close();
  }
}
let CapturumPowerBIReportsManageDetailsComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIReportsManageDetailsComponent extends PowerBIManageDetailsBase {
    constructor(formSaverService, config, dialogRef, actionService) {
      super(formSaverService, config, dialogRef, actionService);
      this.formSaverService = formSaverService;
      this.config = config;
      this.dialogRef = dialogRef;
      this.actionService = actionService;
      this.key = 'form_edit_power_bi_report';
      this.subscription = new Subscription();
    }
    ngOnInit() {
      this.subscription.add(this.dialogRef.onClose.subscribe(() => {
        this.actionService.broadcastActionExecuted(this.config?.data?.action, this.item, null);
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function CapturumPowerBIReportsManageDetailsComponent_Factory(t) {
        return new (t || CapturumPowerBIReportsManageDetailsComponent)(i0.ɵɵdirectiveInject(i1$2.FormSaverService), i0.ɵɵdirectiveInject(i2$2.DynamicDialogConfig), i0.ɵɵdirectiveInject(i2$2.DynamicDialogRef), i0.ɵɵdirectiveInject(i3$1.CapturumBuilderActionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIReportsManageDetailsComponent,
        selectors: [["cap-pbi-reports-manage-details"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 8,
        consts: [[1, "dialog-content"], [3, "formKey", "modelId"], ["form", ""], [1, "dialog-footer"], [1, "btn-groups"], [1, "btn-left"], ["styleClass", "secondary", 3, "label", "onClick"], [1, "btn-right"], ["styleClass", "primary", 3, "label", "onClick"]],
        template: function CapturumPowerBIReportsManageDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cpb-form-renderer", 1, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "cap-button", 6);
            i0.ɵɵlistener("onClick", function CapturumPowerBIReportsManageDetailsComponent_Template_cap_button_onClick_6_listener() {
              return ctx.close();
            });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 7)(9, "cap-button", 8);
            i0.ɵɵlistener("onClick", function CapturumPowerBIReportsManageDetailsComponent_Template_cap_button_onClick_9_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formKey", ctx.key)("modelId", ctx.modelId);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(7, 4, "button.cancel"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 6, "button.submit"));
          }
        },
        dependencies: [i1$2.CapturumFormRendererComponent, i4$1.CapturumButtonComponent, i4.TranslatePipe],
        styles: [".dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding-top:1rem;font-size:1rem}.dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]   .btn-left[_ngcontent-%COMP%], .dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]   .btn-right[_ngcontent-%COMP%]{flex:1}.dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]   .btn-right[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]   .btn-left[_ngcontent-%COMP%]{padding-right:.5rem}.dialog-footer[_ngcontent-%COMP%]   .btn-groups[_ngcontent-%COMP%]   .btn-right[_ngcontent-%COMP%]{padding-left:.5rem}"]
      });
    }
  }
  return CapturumPowerBIReportsManageDetailsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBIClientsManageDetailsComponent = /*#__PURE__*/(() => {
  class CapturumPowerBIClientsManageDetailsComponent extends PowerBIManageDetailsBase {
    constructor(formSaverService, config, dialogRef, actionService) {
      super(formSaverService, config, dialogRef, actionService);
      this.formSaverService = formSaverService;
      this.config = config;
      this.dialogRef = dialogRef;
      this.actionService = actionService;
      this.key = 'form_edit_power_bi_client';
      this.subscription = new Subscription();
    }
    ngOnInit() {
      this.subscription.add(this.dialogRef.onClose.subscribe(() => {
        this.actionService.broadcastActionExecuted(this.config?.data?.action, this.item, null);
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function CapturumPowerBIClientsManageDetailsComponent_Factory(t) {
        return new (t || CapturumPowerBIClientsManageDetailsComponent)(i0.ɵɵdirectiveInject(i1$2.FormSaverService), i0.ɵɵdirectiveInject(i2$2.DynamicDialogConfig), i0.ɵɵdirectiveInject(i2$2.DynamicDialogRef), i0.ɵɵdirectiveInject(i3$1.CapturumBuilderActionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBIClientsManageDetailsComponent,
        selectors: [["cap-pbi-clients-manage-details"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 7,
        consts: [[1, "dialog-content"], ["formKey", "form_edit_power_bi_client", 3, "modelId"], ["form", ""], [1, "dialog-footer"], [1, "btn-groups"], [1, "btn-left"], ["styleClass", "secondary", 3, "label", "onClick"], [1, "btn-right"], ["styleClass", "primary", 3, "label", "onClick"]],
        template: function CapturumPowerBIClientsManageDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "cpb-form-renderer", 1, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "cap-button", 6);
            i0.ɵɵlistener("onClick", function CapturumPowerBIClientsManageDetailsComponent_Template_cap_button_onClick_6_listener() {
              return ctx.close();
            });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 7)(9, "cap-button", 8);
            i0.ɵɵlistener("onClick", function CapturumPowerBIClientsManageDetailsComponent_Template_cap_button_onClick_9_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("modelId", ctx.modelId);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(7, 3, "button.cancel"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(10, 5, "button.submit"));
          }
        },
        dependencies: [i1$2.CapturumFormRendererComponent, i4$1.CapturumButtonComponent, i4.TranslatePipe],
        styles: ["[_nghost-%COMP%]     .dialog-footer .btn-groups{display:flex;justify-content:space-between;padding-top:1rem;font-size:1rem}[_nghost-%COMP%]     .dialog-footer .btn-groups .btn-left, [_nghost-%COMP%]     .dialog-footer .btn-groups .btn-right{flex:1}[_nghost-%COMP%]     .dialog-footer .btn-groups .btn-right{display:flex;justify-content:flex-end}[_nghost-%COMP%]     .dialog-footer .btn-groups .btn-left{padding-right:.5rem}[_nghost-%COMP%]     .dialog-footer .btn-groups .btn-right{padding-left:.5rem}"]
      });
    }
  }
  return CapturumPowerBIClientsManageDetailsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPowerBiPaginatorComponent = /*#__PURE__*/(() => {
  class CapturumPowerBiPaginatorComponent extends DestroyBase {
    constructor(powerBIService) {
      super();
      this.powerBIService = powerBIService;
      this.showAsList = false;
      this.pages$ = this.powerBIService.pages();
      this.pages$.pipe(takeUntil(this.destroy$)).subscribe(pages => {
        const current_page = pages.findIndex(page => page.isActive === true) + 1;
        this.pagination = {
          total: pages.length,
          per_page: 1,
          current_page
        };
        this._pages = pages;
      });
    }
    setPage(page) {
      if (typeof page === 'number') {
        const currentPage = this._pages[page];
        if (!currentPage.isActive) {
          this.powerBIService.setPage$.next({
            pageName: currentPage.name,
            reportKey: this.reportKey
          });
          this.pagination.current_page = page + 1;
        }
      } else {
        if (!page.isActive) {
          this.powerBIService.setPage$.next({
            pageName: page.name,
            reportKey: this.reportKey
          });
        }
      }
    }
    trackByFn(index) {
      return index;
    }
    static {
      this.ɵfac = function CapturumPowerBiPaginatorComponent_Factory(t) {
        return new (t || CapturumPowerBiPaginatorComponent)(i0.ɵɵdirectiveInject(PowerBIService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPowerBiPaginatorComponent,
        selectors: [["cap-power-bi-paginator"]],
        inputs: {
          styleClass: "styleClass",
          reportKey: "reportKey",
          showAsList: "showAsList"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 3,
        consts: [[3, "class", 4, "ngIf"], ["paginator", ""], ["class", "power-bi-paginator", 4, "ngIf", "ngIfElse"], [1, "power-bi-paginator"], ["class", "paginator-page", 3, "active", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "paginator-page"], [3, "label", "styleClass", "onClick"], [3, "pagination", "changePage"]],
        template: function CapturumPowerBiPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CapturumPowerBiPaginatorComponent_div_0_Template, 2, 4, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, CapturumPowerBiPaginatorComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.pages$));
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i4$1.CapturumButtonComponent, i4$2.CapturumPaginatorComponent, i2$1.AsyncPipe],
        styles: [".power-bi-paginator{display:flex;padding:1rem 0}.power-bi-paginator .paginator-page{flex:1;padding:0 1rem}.power-bi-paginator .paginator-page:first-child,.power-bi-paginator .paginator-page:last-child{padding:0}.power-bi-paginator .paginator-page .cap-button{width:100%}.power-bi-paginator .paginator-page.active .cap-button{cursor:default;pointer-events:none}\n"],
        encapsulation: 2
      });
    }
  }
  return CapturumPowerBiPaginatorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const defaultComponents = [CapturumPowerBiReportComponent, CapturumPowerBIReportsListComponent, CapturumPowerBIReportsDetailComponent, CapturumPowerBIReportsManageDetailsComponent, CapturumPowerBIClientsManageDetailsComponent, CapturumPowerBiPaginatorComponent];
const builderComponentsMap = {
  list_manage_power_bi_reports_add: CapturumPowerBIReportsManageDetailsComponent,
  list_manage_power_bi_reports_edit: CapturumPowerBIReportsManageDetailsComponent,
  list_manage_power_bi_clients_add: CapturumPowerBIClientsManageDetailsComponent,
  list_manage_power_bi_clients_edit: CapturumPowerBIClientsManageDetailsComponent
};
let CapturumPowerBIModule = /*#__PURE__*/(() => {
  class CapturumPowerBIModule {
    static {
      this.ɵfac = function CapturumPowerBIModule_Factory(t) {
        return new (t || CapturumPowerBIModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumPowerBIModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [ToastService],
        imports: [CommonModule, CapturumPowerBIRoutingModule, PowerBIEmbedModule, CapturumFormRendererModule, CapturumListRendererModule, CapturumBuilderCoreModule.forChild({
          components: builderComponentsMap
        }), CapturumButtonModule, CapturumPaginatorModule, TranslateModule]
      });
    }
  }
  return CapturumPowerBIModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumPowerBIClientsManageDetailsComponent, CapturumPowerBIModule, CapturumPowerBIReportsDetailComponent, CapturumPowerBIReportsListComponent, CapturumPowerBIReportsManageDetailsComponent, CapturumPowerBIRoutingModule, CapturumPowerBiPaginatorComponent, CapturumPowerBiReportComponent, PowerBIService, reportsRoutes, routerModule };
